import { useState } from "react";
import { Redirect, useLocation } from "react-router";
import { FullPageSpinner } from "../common/components/FullPageSpinner";
import useCheckForSession from "../common/hooks/useCheckForSession";
import { ConfirmYourMethod } from "./ConfirmYourMethod";
import { SecurityCodeMethod } from "./hooks/useMfaApi";

export interface ConfirmMfaLocationState {
    type: SecurityCodeMethod,
    value: string
    flow: 'enroll' | 'edit' | 'add'
}

export const EnrollEnterCode = () => {
    const [isCheckingSession, setIsCheckingSession] = useState(true);
    useCheckForSession(setIsCheckingSession);
    const location = useLocation<ConfirmMfaLocationState | undefined>();
    const { state } = location;
    if (!state) {
        return <Redirect to={'security-code/enroll/choose-your-method'}/>;
    }
    const { type, value, flow } = state;

    if (isCheckingSession) {
        return <FullPageSpinner />
    }
    return (
        <ConfirmYourMethod type={type} value={value} flow={flow} />
    );
}